import PropTypes from 'prop-types';
import {query} from 'api';
import {Image, Article, ArticleTitle} from './styles';
import {withRouter} from 'react-router';
import {useDragDetection} from 'lib/slider';

const HomepageArticle = ({data, id, history}) => {
  const {handleMouseDown, dragging} = useDragDetection();

  function handleChildClick() {
    if (!dragging) {
      history.push(`/articles/${id}`);
    }
  }

  if (!data) return null;
  const title = data.acf.header_titre;
  const imageUrl = data.acf.header_image;

  return (
    <Article onMouseDownCapture={handleMouseDown} onClickCapture={handleChildClick}>
      <Image src={imageUrl} />
      <ArticleTitle>{title}</ArticleTitle>
    </Article>
  );
};

HomepageArticle.propTypes = {
  data: PropTypes.object,
  id: PropTypes.number.isRequired,
  history: PropTypes.object.isRequired,
};

export default HomepageArticle |> withRouter |> query('getPost', {loadingHidden: true});
